import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { AUTH } from "@/constants/testIds";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name.split(" ")[0]}`);
      nav(u.role === "admin" ? "/admin" : "/");
    } catch (e) {
      const msg = e?.response?.data?.detail || "Login failed";
      setErr(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <p className="overline text-emerald-800 mb-2">Sign in</p>
      <h1 className="font-display text-3xl font-black text-slate-900 tracking-tight">
        Welcome back.
      </h1>
      <p className="text-slate-500 mt-2 text-sm">Access your orders and reorder in one click.</p>

      <form onSubmit={onSubmit} className="mt-10 space-y-4">
        <label className="block">
          <span className="block text-xs font-medium text-slate-600 mb-1.5">Email</span>
          <input
            data-testid={AUTH.emailInput}
            type="email" required value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2.5 text-sm border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-emerald-900/20 focus:border-emerald-900"
          />
        </label>
        <label className="block">
          <span className="block text-xs font-medium text-slate-600 mb-1.5">Password</span>
          <input
            data-testid={AUTH.passwordInput}
            type="password" required value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-3 py-2.5 text-sm border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-emerald-900/20 focus:border-emerald-900"
          />
        </label>
        {err && (
          <p data-testid={AUTH.errorMsg} className="text-sm text-red-600 bg-red-50 border border-red-200 px-3 py-2 rounded-sm">
            {err}
          </p>
        )}
        <button
          data-testid={AUTH.submitBtn}
          disabled={busy}
          className="w-full py-3 bg-emerald-900 text-white text-sm font-semibold rounded-sm hover:bg-emerald-800 disabled:opacity-60"
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>

      <p className="text-sm text-slate-500 mt-6 text-center">
        New here?{" "}
        <Link to="/register" className="text-emerald-900 font-semibold hover:underline">
          Create an account
        </Link>
      </p>
    </div>
  );
}
